
import { mapActions, mapGetters, mapMutations } from "vuex";
import { formatPrice } from '@/modules/Helpers';

export default {
    data: () => ({
        loading: false
    }),

    props: {
        instance: { type: Array, required: true },
        name: {type: String, required: true},
        hideQuantity: { type: Boolean, required: true }
    },
    computed: {
        ...mapGetters('order', ['groupCartUUID', 'groupAssociations']),
        ...mapGetters(['vat']),
        isMaster(){
            return this.name === "Dig"
        },
    },
    methods: {
        ...mapActions('order', ['updateDish']),
        ...mapMutations('order', ['removeSlaveGroupCart']),
        change(type, quantity, uuid) {
            const add = type === 'add';
            const quantity_ = add ? quantity + 1 : quantity- 1;
            this.updateDish({ uuid: uuid, quantity: quantity_ });
        },
        removePerson(){
            try{
                Promise.all(this.groupAssociations[this.name].map(c => this.removeDataUUID(c)));
            }
            catch (error){
                this.$bugsnag.notify(new Error(error));
            }
            this.removeSlaveGroupCart(this.name)
        },
        async removeDataUUID(dataUUID){
            const payload = {
                uuid: this.groupCartUUID,
                data_uuid: dataUUID
            }
            await this.$axios.post('/group-cart/remove', payload);
        },
        formatPrice,
        calcPrice (price) {
            if (this.vat === 'excl') {
                return formatPrice(price * 0.8);
            } else {
                return formatPrice(price);
            }
        }
    },
};
